import { c as _c } from "react/compiler-runtime";
import { FlexCenter, FlexColumn, Separator } from "@opensea/ui-kit";
import { PreviewTooltipContent } from "@/components/tooltip/PreviewTooltip";
export function ProfilePreviewTooltipLayout(t0) {
  const $ = _c(12);
  const {
    avatar,
    name,
    chips,
    collectionsTable,
    showCollectionsTable: t1
  } = t0;
  const showCollectionsTable = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== chips || $[1] !== name) {
    t2 = <FlexColumn className="gap-1">{name}{chips}</FlexColumn>;
    $[0] = chips;
    $[1] = name;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== avatar || $[4] !== t2) {
    t3 = <FlexCenter className="gap-3">{avatar}{t2}</FlexCenter>;
    $[3] = avatar;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== collectionsTable || $[7] !== showCollectionsTable) {
    t4 = showCollectionsTable ? <><Separator />{collectionsTable}</> : null;
    $[6] = collectionsTable;
    $[7] = showCollectionsTable;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <PreviewTooltipContent className="flex-col gap-3">{t3}{t4}</PreviewTooltipContent>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}